import React from "react";
import { useNavigate } from "react-router-dom";
import ChevronRight from "sushiweb/Icons/all/ChevronRight";
import getHexColor from "utils/getHexColor";
import { Card, VerticalLine } from "../Common/styles.common";
import { CardWrapper, AmountMetricsRow, AmountMetricCell, GrnCompletedOnLabel, AmountMetricValue, AmountMetricLabel, ViewDetailsIconWrapper, GrnCardOuterWrapper, GrnCardFooterText } from "./styles.grn";
import { IndianRupee } from "lucide-react";
import { OrderCard } from "../../shared/Card/OrderCard";
import { strings } from "utils/constants/strings";

export const GrnCard = ({ grn, source }) => {
  const navigate = useNavigate();

  const grnCardTags = grn?.grn_page_data?.header_tags || [];
  const grnCardFooter = grn?.grn_page_data?.footer;

  const handleViewDetailsCTA = () => {
    const tab = source === "all" ? "all" : "list";
    navigate(`/grn/details/${tab}/${grn?.purchase_order_id}/${grn?.id}`);
  };

  // Resolve all header tags to hex colours for OrderCard's headerTags prop
  const headerTags = grnCardTags.map((tag) => ({
    text: tag?.text || null,
    bg: tag ? getHexColor(tag.bg_color) : undefined,
    text_color: tag ? getHexColor(tag.color) : undefined,
  }));

  const rightTopDiv = (
    <ViewDetailsIconWrapper>
      <ChevronRight size={20} color="#EF4F5F" />
    </ViewDetailsIconWrapper>
  );

  const InnerCardContent = (
    <CardWrapper bgColor="#F2F4F7" className="align-items-center mx-4 mt-4" style={{ marginBottom: '16px' }}>
      <Card smallRadius className="wd-100 align-items-center">
        <AmountMetricsRow>
          <AmountMetricCell>
            <AmountMetricValue>
              <IndianRupee size={15} strokeWidth={2.5} />{grn?.supplier_bill_amount?.toLocaleString("en-IN")}
            </AmountMetricValue>
            <AmountMetricLabel>{strings.grnCardInvoiceAmount}</AmountMetricLabel>
          </AmountMetricCell>
          <VerticalLine />
          <AmountMetricCell>
            <AmountMetricValue>
              <IndianRupee size={15} strokeWidth={2.5} />{grn?.grn_amount?.toLocaleString("en-IN")}
            </AmountMetricValue>
            <AmountMetricLabel>{strings.grnCardGrnAmount}</AmountMetricLabel>
          </AmountMetricCell>
        </AmountMetricsRow>
      </Card>
      <GrnCompletedOnLabel>
        {strings.grnCardDoneOn} {grn?.grn_page_data?.grn_completed_on_date_str}
      </GrnCompletedOnLabel>
    </CardWrapper>
  );

  return (
    <GrnCardOuterWrapper>
      <OrderCard
        headerTags={headerTags}
        headingText={grn?.grn_number}
        subHeadingText={
          grn?.supplier_bill_number
            ? `${strings.grnCardInvoicePrefix}${grn?.supplier_bill_number}`
            : undefined
        }
        cardOnClick={handleViewDetailsCTA}
        rightTopDiv={rightTopDiv}
        InnerCardContent={InnerCardContent}
        footer={grnCardFooter ? <GrnCardFooterText>{grnCardFooter?.text}</GrnCardFooterText> : undefined}
        footerBg={grnCardFooter ? getHexColor(grnCardFooter?.bg_color) : undefined}
        footerTextColor={grnCardFooter ? getHexColor(grnCardFooter?.color) : undefined}
      />
    </GrnCardOuterWrapper>
  );
};

export default GrnCard;
